import $ from "jquery";
window.$ = window.jquery = $;

import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import Base from '../utils/base'

import Header from './components/Header'
import Article from './components/Article'

export default function ArticleIndex(props) {
	var base = new Base()

  return (
    <>
      <Header/>
      <Article/>
    </>
  );
};
